const t = {
  name: "DocumentMinus",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 3C5 2.44772 5.44771 2 6 2H12V6C12 7.65685 13.3431 9 15 9H19V14H21V6.58579L14.4142 0H6C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H12V22H6C5.44772 22 5 21.5523 5 21V3ZM14 2.41421L18.5858 7H15C14.4477 7 14 6.55228 14 6V2.41421Z" fill="currentColor"/>
<path d="M14 19H22V21H14V19Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as DocumentMinus
};
